<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
    <g clip-path="url(#clip0_3744_8395)">
      <path
        d="M33.55 10.4686C32.835 9.75365 31.68 9.75365 30.965 10.4686L22 19.4153L13.035 10.4503C12.32 9.73531 11.165 9.73531 10.45 10.4503C9.73501 11.1653 9.73501 12.3203 10.45 13.0353L19.415 22.0003L10.45 30.9653C9.73501 31.6803 9.73501 32.8353 10.45 33.5503C11.165 34.2653 12.32 34.2653 13.035 33.5503L22 24.5853L30.965 33.5503C31.68 34.2653 32.835 34.2653 33.55 33.5503C34.265 32.8353 34.265 31.6803 33.55 30.9653L24.585 22.0003L33.55 13.0353C34.2467 12.3386 34.2467 11.1653 33.55 10.4686Z"
        fill="#323232"
      />
    </g>
    <defs>
      <clipPath id="clip0_3744_8395">
        <rect width="44" height="44" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
